export const state = {
  navigateToNextStep: false,
  currentStep: 1,
  formIsValid: false
};

export const mutations = {
  toggleNavigateToNextStep(state) {
    state.navigateToNextStep = !state.navigateToNextStep;
  },
  doNextStep(state) {
    if (state.currentStep < 8) state.currentStep++;
  },
  toggleNavigateToPreviousStep(state) {
    state.navigateToPreviousStep = !state.navigateToPreviousStep;
  },
  doPreviousStep(state) {
    if (state.currentStep > 1) state.currentStep--;
  },
  setFormValidity(state, isValid) {
    state.formIsValid = isValid;
  }
};

export const actions = {
  toggleNavigateToNextStep({ commit }) {
    commit('toggleNavigateToNextStep');
  },

  doNextStep({ commit }) {
    commit('doNextStep');
  },

  toggleNavigateToPreviousStep({ commit }) {
    commit('toggleNavigateToPreviousStep');
  },

  doPreviousStep({ commit }) {
    commit('doPreviousStep');
  },

  setFormValidity({ commit }, isValid) {
    commit('setFormValidity', isValid);
  }
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
